(function(){
  'use strict';
  document.documentElement.classList.add('tcg-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els=document.querySelectorAll('[data-reveal]');
    if(!els.length) return;
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return;}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }

  function counters(){
    var cs=document.querySelectorAll('[data-countup]');
    if(!cs.length) return;
    function fmt(n){return Number(n).toLocaleString('de-DE');}
    function run(el){
      var end=parseFloat(el.getAttribute('data-countup'))||0,suf=el.getAttribute('data-suffix')||'',t0=null,dur=1400;
      function step(t){if(!t0)t0=t;var p=Math.min((t-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=fmt(Math.round(end*e))+suf;if(p<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);
    }
    if(reduce||!('IntersectionObserver' in window)){cs.forEach(function(el){el.textContent=fmt(el.getAttribute('data-countup'))+(el.getAttribute('data-suffix')||'')});return;}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){run(en.target);io.unobserve(en.target)}})},{threshold:.4});
    cs.forEach(function(el){io.observe(el)});
  }

  function header(){
    var st=document.querySelector('[data-search-toggle]'), sb=document.querySelector('[data-search-bar]');
    if(st&&sb){st.addEventListener('click',function(){sb.classList.toggle('open');var i=sb.querySelector('input');if(sb.classList.contains('open')&&i)i.focus();});}
    var bt=document.querySelector('[data-burger]'), nav=document.querySelector('[data-mobile-nav]');
    if(bt&&nav){bt.addEventListener('click',function(){nav.classList.toggle('open');});}
  }

  function gallery(){
    var main=document.querySelector('[data-gallery-main]');
    if(!main) return;
    document.querySelectorAll('[data-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var src=btn.getAttribute('data-src');
        if(src){main.querySelector('img').src=src;}
        document.querySelectorAll('[data-thumb]').forEach(function(b){b.classList.remove('active')});
        btn.classList.add('active');
      });
    });
  }

  function qty(){
    document.querySelectorAll('[data-qty]').forEach(function(box){
      var input=box.querySelector('input');
      box.querySelectorAll('[data-qty-btn]').forEach(function(b){
        b.addEventListener('click',function(){
          var v=parseInt(input.value,10)||1; v+= (b.getAttribute('data-qty-btn')==='up'?1:-1);
          if(v<1)v=1; input.value=v;
        });
      });
    });
  }

  // Variant selection: update hidden id, price, availability
  function variants(){
    var form=document.querySelector('.tcg-pform');
    if(!form) return;
    var data=window.__TCG_VARIANTS__; if(!data) return;
    var idInput=form.querySelector('[name="id"]');
    var selects=form.querySelectorAll('[data-option-index]');
    var priceEl=document.querySelector('[data-price]');
    var addBtn=form.querySelector('[data-add]');
    function money(cents){return (cents/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';}
    function current(){
      var chosen=[]; selects.forEach(function(s){chosen[parseInt(s.getAttribute('data-option-index'),10)]=s.value;});
      return data.find(function(v){return v.options.every(function(o,i){return o===chosen[i];});});
    }
    function update(){
      var v=current();
      if(!v){return;}
      if(idInput)idInput.value=v.id;
      if(priceEl){priceEl.innerHTML = v.compare>v.price ? '<s>'+money(v.compare)+'</s> '+money(v.price) : money(v.price);}
      if(addBtn){if(v.available){addBtn.disabled=false;addBtn.textContent='In den Warenkorb';}else{addBtn.disabled=true;addBtn.textContent='Ausverkauft';}}
    }
    selects.forEach(function(s){s.addEventListener('change',update);});
    update();
  }

  function boot(){reveal();counters();header();gallery();qty();variants();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
